import { IMAGE_BASE } from '../constants/site';

export const SOLUTION_HIGHLIGHTS = [
  {
    icon: 'fa-solid fa-paint-roller',
    title: 'Quality road paint',
    description:
      'Durable, high-visibility markings that withstand harsh weather and keep roads safe for years.',
  },
  {
    icon: 'fa-solid fa-sign-hanging',
    title: 'Aluminum signs',
    description:
      'Corrosion-resistant signage built for outdoor durability with minimal maintenance.',
  },
  {
    icon: 'fa-solid fa-traffic-light',
    title: 'Traffic management',
    description:
      'Modern traffic systems with reliable equipment, clear regulation, and community-focused service.',
  },
  {
    icon: 'fa-solid fa-people-group',
    title: 'Expert team',
    description:
      'Skilled professionals delivering precision, safety standards, and on-time project completion.',
  },
];

export const SAFETY_PRODUCTS = [
  {
    image: `${IMAGE_BASE}/img31.jpg`,
    title: 'Industrial safety signage for factories and construction zones.',
  },
  {
    image: `${IMAGE_BASE}/img32.jpg`,
    title: 'Directional and warning signs for public infrastructure projects.',
  },
  {
    image: `${IMAGE_BASE}/img33.jpg`,
    title: 'Reflective safety signage for highways and urban intersections.',
  },
  {
    image: `${IMAGE_BASE}/img34.jpg`,
    title: 'Custom safety boards for commercial and government facilities.',
  },
];

export const ROAD_PAINT_PRODUCTS = [
  {
    image: `${IMAGE_BASE}/img35.jpg`,
    title: 'Cold-applied road marking paint for durable lane separation.',
  },
  {
    image: `${IMAGE_BASE}/img36.jpg`,
    title: 'Hot-melt thermoplastic paint for high-traffic road networks.',
  },
  {
    image: `${IMAGE_BASE}/img37.jpg`,
    title: 'Spray road marking systems for fast project turnaround.',
  },
  {
    image: `${IMAGE_BASE}/img38.jpg`,
    title: 'Eco-conscious marking solutions for safer and cleaner roads.',
  },
];

export const TEAM_HIGHLIGHTS = [
  {
    image: `${IMAGE_BASE}/img37.jpg`,
    title: 'Community blood donation initiatives',
  },
  {
    image: `${IMAGE_BASE}/img39.jpg`,
    title: 'Health and wellness programs for staff',
  },
  {
    image: `${IMAGE_BASE}/img38.jpg`,
    title: 'Team-building and safety training activities',
  },
  {
    image: `${IMAGE_BASE}/img35.jpg`,
    title: 'Field-ready teams focused on quality delivery',
  },
];
